import { combineReducers } from 'redux';
import HeaderReducer from 'src/containers/header-container/reducer/HeaderReducer';
import RemarkReducer from 'src/containers/remarks-container/reducer/RemarkReducer';
import CityReducer from './containers/city-container/reducer/CityReducer';
import StateReducer from './containers/state-container/reducer/StateReducer';
import ProductReducer from './containers/product-container/reducer/ProductReducer';
import CustomerReducer from './containers/customer-container/reducer/CustomerReducer';
import FileReducer from './containers/files-container/reducer/FileReducer';
import CompanyReducer from './containers/company-container/reducer/CompanyReducer';
import UserReducer from './containers/user-container/reducer/UserReducer';
import AuthReducer from './containers/auth-container/reducer/AuthReducer';
import PermissionsMasterReducer from './containers/permissions-container/reducer/PermissionsMasterReducer';
import RolePermissionsReducer from './containers/permissions-container/reducer/RolePermissionsReducer';
import AreaReducer from './containers/area-container/reducer/AreaReducer';
import CatalogueReducer from './containers/catalogue-container/reducer/CatalogueReducer';
import CommissionReducer from './containers/commission-container/reducer/CommissionReducer';
import CaseReducer from './containers/case-container/reducer/CaseReducer';
import ExcelReducer from './containers/excel-container/reducer/ExcelReducer';
import CrossSaleReducer from './containers/cross-sale-container/reducer/CrossSaleReducer';
import MastersReducer from './containers/masters-container/reducer/MastersReducer';
import TargetReducer from './containers/target-container/reducer/TargetReducer';
import WalletReducer from './containers/wallet-container/reducer/WalletReducer';
import InsuranceSlabReducer from './containers/insurance-slab-container/reducer/insuranceSlabReducer';

export default combineReducers({
    CityReducer,
    HeaderReducer,
    StateReducer,
    RemarkReducer,
    ProductReducer,
    CustomerReducer,
    FileReducer,
    CompanyReducer,
    UserReducer,
    AuthReducer,
    PermissionsMasterReducer,
    RolePermissionsReducer,
    AreaReducer,
    CatalogueReducer,
    CommissionReducer,
    CaseReducer,
    ExcelReducer,
    CrossSaleReducer,
    MastersReducer,
    TargetReducer,
    WalletReducer,
    InsuranceSlabReducer
});
